import { ResourcesConfig } from 'aws-amplify';

class AuthConfig {
  private static readonly baseOAuthConfig = {
    providers: ['Google'],
    scopes: [
      'phone',
      'email',
      'openid',
      'profile',
      'aws.cognito.signin.user.admin',
    ],
    responseType: 'code',
  };

  // Production US
  static readonly production: ResourcesConfig['Auth'] = {
    Cognito: {
      loginWith: {
        oauth: {
          ...this.baseOAuthConfig,
          redirectSignIn: [
            'http://localhost:5173',
            'http://localhost:5173/redirect',
            'https://3.88.91.176',
            'https://idolmaster.nation-a.com',
            'https://idolmaster.nation-a.com/redirect',
            'https://portal.hey-d.ai',
            'https://portal.hey-d.ai/login',
            'https://portal.hey-d.ai/redirect',
            'https://www.hey-d.ai/redirect',
          ],
          redirectSignOut: [
            'http://localhost:5173/signin',
            'https://3.88.91.176/login',
            'https://idolmaster.nation-a.com/signin',
            'https://portal.hey-d.ai/login',
            'https://www.hey-d.ai/signin',
          ],
          domain: 'auth.hey-d.ai',
        },
      } as AuthConfig,
      userPoolId: 'us-east-1_Gpunfo08I',
      userPoolClientId: '7org7pa5t7ie76apsh9s3misuj',
    },
  };

  // Staging US
  static readonly stagingUS: ResourcesConfig['Auth'] = {
    Cognito: {
      loginWith: {
        oauth: {
          ...this.baseOAuthConfig,
          redirectSignIn: [
            'http://localhost:5173',
            'http://localhost:5173/redirect',
            'https://auth-staging.hey-d.ai/oauth2/idpresponse',
            'https://staging.hey-d.ai',
            'https://staging.hey-d.ai/redirect',
          ],
          redirectSignOut: [
            'http://localhost:5173/signin',
            'https://staging.hey-d.ai/signin',
          ],
          domain: 'auth-staging.hey-d.ai',
        },
      } as AuthConfig,
      userPoolId: 'us-east-1_QJBjGWJnP',
      userPoolClientId: '9gn66ouvi0lr39s9safauhmjk',
    },
  };

  // Staging Seoul
  static readonly staging: ResourcesConfig['Auth'] = {
    Cognito: {
      loginWith: {
        oauth: {
          ...this.baseOAuthConfig,
          redirectSignIn: [
            'http://localhost:5173/redirect',
            'http://localhost:5173',
            'https://oauth.pstmn.io/v1/callback',
            'https://seoul-auth.hey-d.ai/oauth2/idpresponse',
            'https://seoul-staging.hey-d.ai',
            'https://seoul-staging.hey-d.ai/redirect',
          ],
          redirectSignOut: [
            'http://localhost:5173/signin',
            'https://seoul-staging.hey-d.ai/signin',
          ],
          domain: 'seoul-auth.hey-d.ai',
        },
      } as AuthConfig,
      userPoolId: 'ap-northeast-2_lD3G3dbVt',
      userPoolClientId: '4mpakd5pb8u33u5a2akggreq01',
    },
  };

  // Development US
  static readonly developmentUS: ResourcesConfig['Auth'] = {
    Cognito: {
      loginWith: {
        oauth: {
          ...this.baseOAuthConfig,
          redirectSignIn: [
            'http://localhost:5173',
            'http://localhost:5173/redirect',
            'https://auth-dev.hey-d.ai/oauth2/idpresponse',
            'https://dev.hey-d.ai',
            'https://dev.hey-d.ai/redirect',
          ],
          redirectSignOut: [
            'http://localhost:5173/signin',
            'https://dev.hey-d.ai/signin',
          ],
          domain: 'auth-dev.hey-d.ai',
        },
      } as AuthConfig,
      userPoolId: 'us-east-1_WKus2hFbb',
      userPoolClientId: 'vaspnmsmdkjvvoqf31ps79865',
    },
  };

  // Development Seoul
  static readonly development: ResourcesConfig['Auth'] = {
    Cognito: {
      loginWith: {
        oauth: {
          ...this.baseOAuthConfig,
          redirectSignIn: [
            'http://localhost:5173/redirect',
            'http://localhost:5173',
            'https://seoul-auth-dev.hey-d.ai/oauth2/idpresponse',
            'https://seoul-dev.hey-d.ai',
            'https://seoul-dev.hey-d.ai/redirect',
          ],
          redirectSignOut: [
            'http://localhost:5173/signin',
            'https://seoul-dev.hey-d.ai/signin',
          ],
          domain: 'seoul-auth-dev.hey-d.ai',
        },
      } as AuthConfig,
      userPoolId: 'ap-northeast-2_FsdIftHTU',
      userPoolClientId: '3mialbi12jbfgqgqhbpm3jbut9',
    },
  };
  static getConfig(environment: string): ResourcesConfig['Auth'] {
    const 환경별AuthConfig = (this[environment as keyof typeof AuthConfig] ??
      this.production) as ResourcesConfig['Auth'];
    return 환경별AuthConfig;
  }
}

export const authConfig = AuthConfig.getConfig(import.meta.env.VITE_ENV);
